import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { CountryCode } from 'frontend-utils/utils/countries';

export default class ParityConfig extends Model {
  [Type] = 'parity/config' as const;

  @attr() declare losValues: number[];
  @attr() declare posValues: CountryCode[];
}
